import React, {useMemo, useState} from "react";
import {Button, Dialog, DialogActions, DialogContent} from "@mui/material";
import {ClosableDialogTitle, SelectField} from "@atttomyx/react-components";
import {forms} from "@atttomyx/shared-utils";

const ChooseTemplateDialog = (props) => {
    const { templates, onCancel, onChoose } = props;
    const [ templateId, setTemplateId ] = useState(null);

    const templateIdToName = useMemo(() => {
        const idToField = {};

        templates.map(template => idToField[template.id] = template.name);

        return idToField;
    }, [templates]);

    return <Dialog
        open={true}
        aria-labelledby="choose-questionnaire-dialog"
    >
        <ClosableDialogTitle onClose={onCancel}>
            Add Template
        </ClosableDialogTitle>
        <DialogContent className="choose-questionnaire-dialog">
            <div className="field top-margin">
                <SelectField
                    label="Template"
                    value={forms.sanitizeValue(templateId)}
                    onChange={setTemplateId}
                    options={templateIdToName}
                />
            </div>
        </DialogContent>
        <DialogActions>
            <Button color="primary"
                    disabled={!templateId}
                    onClick={() => onChoose(templateId)}>
                Save
            </Button>
        </DialogActions>
    </Dialog>
}

export default ChooseTemplateDialog;
